import { classnames } from '@aibees/shared/utils';
import { memo, useMemo } from 'react';
import { TestimonialCardLeader } from '../testimonial-card-leader';
import { TestimonialCardLinkedin } from '../testimonial-card-linkedin';
import { TestimonialCardYoutube } from '../testimonial-card-youtube';
import * as Styled from './styles';
import type { ClientsCommentsGridProps as Props } from './types';
import { TestimonialSource, type Testimonial } from '../../types';

const COLUMN_COUNT = 4;

export const ClientsCommentsGrid = memo(
  ({ testimonials, onSelectVideo, className }: Props) => {
    const columns = useMemo(
      () =>
        Array.from({ length: COLUMN_COUNT }, (_, col) =>
          testimonials.filter((__, i) => i % COLUMN_COUNT === col)
        ),
      [testimonials]
    );

    const renderCard = (t: Testimonial, key: string) => {
      if (t.source === TestimonialSource.LINKEDIN) {
        return <TestimonialCardLinkedin key={key} testimonial={t} />;
      }
      if (t.source === TestimonialSource.YOUTUBE) {
        return (
          <TestimonialCardYoutube
            key={key}
            testimonial={t}
            onSelect={onSelectVideo}
          />
        );
      }
      return <TestimonialCardLeader key={key} testimonial={t} />;
    };

    return (
      <Styled.Wrapper className={classnames('ClientsCommentsGrid', className)}>
        <Styled.Grid>
          {columns.map((colCards, col) => (
            <Styled.Column key={col}>
              <Styled.Track data-col={String(col)}>
                {colCards.map((c, i) => renderCard(c, `${c.id}-a-${i}`))}
                {colCards.map((c, i) => renderCard(c, `${c.id}-b-${i}`))}
              </Styled.Track>
            </Styled.Column>
          ))}
        </Styled.Grid>
      </Styled.Wrapper>
    );
  }
);

ClientsCommentsGrid.displayName = 'ClientsCommentsGrid';
